module.exports = __webpack_public_path__ + "static/etc-d2ba0561642dfe213f991b294d7d5448.jpg";